// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tMeIr","newExpiryDate":"styles_newExpiryDate__21F07","footer":"styles_footer__24lwv"};